import React, { useEffect, useState } from "react";
import { Check, XCircle } from "lucide-react"; // Sử dụng XCircle cho thất bại
import { useParams } from "react-router-dom";
import { getData } from "../../api/api";

export default function SuccessRegister() {
  const { id } = useParams();
  const [verificationStatus, setVerificationStatus] = useState(null); // Trạng thái xác thực

  useEffect(() => {
    // Gửi request để kiểm tra trạng thái xác thực
    getData(`/accounts/verification/${id}`)
      .then((response) => {
        setVerificationStatus("success");
      })
      .catch((error) => {
        console.error("Error verifying account:", error);
        setVerificationStatus("error"); // Trạng thái lỗi
      });
  }, [id]);

  return (
    <div className="m-auto flex justify-center p-20 mb-40">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-auto p-6 text-center">
        {/* Biểu tượng và trạng thái */}
        {verificationStatus === "success" ? (
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="w-8 h-8 text-green-500" />
          </div>
        ) : verificationStatus === "error" ? (
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
        ) : (
          // Nếu trạng thái chưa xác định, không hiển thị biểu tượng
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4"></div>
        )}

        {/* Tiêu đề và thông báo */}
        {verificationStatus === "success" ? (
          <>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Account successfully verified!
            </h2>
            <p className="text-gray-600 mb-6">
              You now have access to all the features of our platform.
            </p>
          </>
        ) : verificationStatus === "already_verified" ? (
          <>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Account already verified!
            </h2>
            <p className="text-gray-600 mb-6">
              This account has already been verified.
            </p>
          </>
        ) : verificationStatus === "error" ? (
          <>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Verification failed!
            </h2>
            <p className="text-gray-600 mb-6">
              Something went wrong while verifying your account. Please try
              again.
            </p>
          </>
        ) : (
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Verifying your account...
          </h2>
        )}

        {/* Nút quay lại trang đăng nhập */}
        <button
          onClick={() => (window.location.href = "/login")}
          className="w-full py-2 px-4 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors duration-200"
        >
          Go back to Login page
        </button>
      </div>
    </div>
  );
}
